import axios from 'axios';
import settings from '@/settings';

export default {
  namespaced: true,
  state: {
    progress: null,
    isLoading: {
      progress: false,
    },
    errors: {
      setTestProgress: {},
      getTestProgress: {},
    },
  },
  getters: {
    progressLoader: state => state.isLoading.progress,
  },
  mutations: {
    SET_ERRORS(state, error) {
      state.errors[error.key] = error.val;
    },
    SET_PROGRESS(state, payload) {
      state.progress = payload;
    },
    PROGRESS_LOADING_START(state) {
      state.isLoading.progress = true;
    },
    PROGRESS_LOADING_FINISH(state) {
      state.isLoading.progress = false;
    },
  },
  actions: {
    async setProgress({ commit }, data) {
      commit('SET_ERRORS', {
        key: 'setTestProgress',
        val: {},
      });

      try {
        const resp = await axios.post(`${settings.MEGAPOLIS_ONLINE_URL}/api/v2/knowledge-check/progress`, data, {
          headers: {
            Authorization: `Bearer ${settings.MEGAPOLIS_BEARER_TOKEN}`,
          },
        });
        return resp.data;
      } catch (e) {
        if (e.response && e.response.data) {
          console.log(e.response.data);
          commit('SET_ERRORS', {
            key: 'setTestProgress',
            val: e.response.data,
          });
        } else {
          console.log(`Ошибка ${e.message}`);
          commit('SET_ERRORS', {
            key: 'setTestProgress',
            val: { error: 'Ошибка' },
          });
        }
      }
      return false;
    },
    async getProgress({ commit }, payload) {
      commit('SET_ERRORS', {
        key: 'getTestProgress',
        val: {},
      });

      commit('PROGRESS_LOADING_START');

      try {
        const resp = await axios.post(
          `${settings.MEGAPOLIS_ONLINE_URL}/api/v2/knowledge-check/get-progress`,
          {
            test_url: payload.test_url,
            lesson_id: payload.lesson_id,
          },
          {
            headers: {
              Authorization: `Bearer ${settings.MEGAPOLIS_BEARER_TOKEN}`,
            },
          },
        );
        commit('SET_PROGRESS', resp.data);
        return resp.data;
      } catch (e) {
        if (e.response && e.response.data) {
          console.log(e.response.data);
          commit('SET_ERRORS', {
            key: 'getTestProgress',
            val: e.response.data,
          });
        } else {
          console.log(`Ошибка ${e.message}`);
          commit('SET_ERRORS', {
            key: 'getTestProgress',
            val: { error: 'Ошибка' },
          });
        }
      } finally {
        commit('PROGRESS_LOADING_FINISH');
      }
      return false;
    },
    clearProgress({ commit }) {
      commit('SET_PROGRESS', null);
      commit('SET_ERRORS', {
        key: 'getTestProgress',
        val: {},
      });
      commit('PROGRESS_LOADING_FINISH');
    },
  },
};
